const APP = require('APP')
const $ = require('jquery')
const _ = require('underscore')
const Backbone = require('backbone')
const objects = require('../../../Helpers/objects')
const QRCode = require('qrcode')

const trans = require('trans')
const router = require('router')
const numbers = require('numbers')
const errorHandler = require('Helpers/errorHandler')
const win = require('Helpers/win')
const SimpleDialog = require('UI/SimpleDialog')
const user = require('Models/UserModel')
const { gaHelper } = require('../../../../app/containers/AnalyticsGoogleTag/gaHelper')

module.exports = Backbone.View.extend({
  overlayZIndex: 10,
  currentOpenDialog: undefined,
  defaultDialogCss: { 'max-height': '90%' },

  constructor: function constructor(gamePlayView, gameModel, forFun) {
    this.gamePlayView = gamePlayView
    this.gameModel = gameModel
    this.forFun = forFun
  },

  showDialog() {
    win.setSelectable(true)
    win.fullscreen(false)
    this.gamePlayView.hide()
    this.dialogIsShown = true
    APP.stopTouchMoveLock = true
  },

  hideDialog(action) {
    if (this.dialogIsShown) {
      APP.stopTouchMoveLock = false
      this.dialogIsShown = false
      if (!this.gamePlayView) {
        return
      }
      if (action === 'Q') {
        this.gamePlayView.destroy()
        return
      } else {
        win.setSelectable(false)
      }
      this.gamePlayView.show()
    }
  },

  /**
   * If user is not logged and wont to play for fun
   * and system is configured to have for fun fun registration
   */
  showNeedFastRegistrationDialog() {
    this.showDialog()
    this.currentOpenDialog = SimpleDialog.dialog({
      title: trans('Message'),
      type: 'confirm',
      overlayZIndex: this.overlayZIndex,
      content: `<h4 class="tc">${trans('login and play')}</h4>`,
      buttons: {
        back: {
          label: trans('Back'),
          callback: () => {
            this.gamePlayView.destroy()
          },
        },
        fastRegistration: {
          label: trans('Register'),
          callback() {
            router.pathRedirect('fos_user_registration_register')
          },
        },
        login: {
          label: trans('Log in'),
          callback() {
            user.login()
          },
        },
      },
      css: this.defaultDialogCss,
      close: () => {
        this.hideDialog()
      },
    })
  },

  /**
   * If user is logged and wont to play for real
   */
  showRealPlayNotPermittedDialog() {
    const message = APP.isPlayPermittedErrorMessage || trans('You dont have permittion to play for real')
    this.showDialog()
    this.currentOpenDialog = SimpleDialog.dialog({
      title: trans('Message'),
      type: 'confirm',
      overlayZIndex: this.overlayZIndex,
      content: `<h4 class="tc">${message}</h4>`,
      buttons: {
        back: {
          label: trans('Back'),
          callback: () => {
            this.gamePlayView.destroy()
          },
        },
      },
      css: this.defaultDialogCss,
      close: () => {
        this.hideDialog()
      },
    })
  },

  /**
   * If user is logged as for fun only
   */
  showRealPlayNotPermittedForFunPlayerDialog() {
    this.showDialog()
    this.currentOpenDialog = SimpleDialog.dialog({
      title: trans('Message'),
      type: 'confirm',
      overlayZIndex: this.overlayZIndex,
      content: `<h4 class="tc">${trans('You dont have permittion to play for real')}</h4>`,
      buttons: {
        back: {
          label: trans('finish_registration'),
          callback() {
            router.pathRedirect('finish_registration')
          },
        },
      },
      css: this.defaultDialogCss,
      close: () => {
        this.hideDialog()
      },
    })
  },

  /**
   * If user is not logged in
   */
  showRealPlayNotLoggedDialog() {
    this.showDialog()
    this.currentOpenDialog = SimpleDialog.dialog({
      title: trans('Message'),
      type: 'confirm',
      overlayZIndex: this.overlayZIndex,
      content: `<h4 class="tc">${trans('You must be logged in to play for real')}</h4>`,
      buttons: {
        login: {
          label: trans('Log in'),
          callback() {
            user.login()
          },
        },
      },
      css: this.defaultDialogCss,
      close: () => {
        this.hideDialog()
      },
    })
  },
  /**
   * Display when user has no credits and wants play for real
   */
  showNoCreditsDialog() {
    this.showDialog()
    this.currentOpenDialog = SimpleDialog.dialog({
      title: trans('Message'),
      content: `<h4 class="tc">${trans("You don't have enough credits to play for real")}</h4>`,
      type: 'confirm',
      overlayZIndex: this.overlayZIndex,
      buttons: {
        madeDeposit: {
          label: trans('Make deposit'),
          callback() {
            router.pathRedirect('multilotto_payment_makedeposit')
          },
        },
      },
      css: this.defaultDialogCss,
      close: () => {
        this.hideDialog()
      },
    })
  },

  /**
   * If user is plaing for fun long time
   */
  showForFunAlert(callback) {
    this.showDialog()
    this.currentOpenDialog = SimpleDialog.dialog({
      title: trans('Message'),
      type: 'confirm',
      overlayZIndex: this.overlayZIndex,
      content: `<h4 class="tc">${trans('long play for fun message')}</h4>`,
      buttons: {
        playForReal: {
          label: trans('play_for_real'),
          primary: true,
          callback: () => {
            router.redirect(this.gameModel.get('realPlayUrl'))
          },
        },
        playForFun: {
          label: trans('play_for_fun'),
          callback: () => {
            this.gamePlayView.show()
            callback()
          },
        },
      },
      css: this.defaultDialogCss,
      close: () => {
        this.hideDialog()
      },
    })
  },

  /**
   * If user is plaing for fun long time
   */
  showPanicButtonAlert(callback) {
    this.showDialog()
    this.currentOpenDialog = SimpleDialog.dialog({
      title: trans('Message'),
      type: 'confirm',
      overlayZIndex: this.overlayZIndex,
      content: `<h4 class="tc">${trans('you_want_to_end_the_game')}</h4>`,
      buttons: {
        yes: {
          label: trans('Yes').toUpperCase(),
          primary: true,
          callback: () => callback(),
        },
        no: {
          label: trans('No').toUpperCase(),
          callback: () => {
            this.gamePlayView.show()
          },
        },
      },
      css: this.defaultDialogCss,
      close: () => {
        this.hideDialog()
      },
    })
  },

  /** show user info about his game */
  recoveryInfo(infoObj) {
    this.showDialog()
    this.currentOpenDialog = SimpleDialog.dialog({
      title: trans('Message'),
      overlayZIndex: this.overlayZIndex,
      content: trans('game_recovered_from', {
        '%time%': infoObj.savedAt,
      }),
      css: this.defaultDialogCss,
      close: () => {
        this.hideDialog()
      },
    })
  },

  getRichedCapiLimitMsg(code, limit) {
    const limitsNameMap = {
      lossLimitDay: 'lossDayCasinoLimit',
      lossLimitMonth: 'lossMonthCasinoLimit',
      wagerLimitDay: 'stakeDayCasinoLimit',
      wagerLimitMonth: 'stakeMonthCasinoLimit',
      HourLossLimit: 'lossHourOnlineLimit',
      OverallFinancialLoss: 'lossOverAllLimit',
    }

    const limitKey = limitsNameMap[limit] || limit

    if (code === 6003010) {
      // BET CHANGE
      // console.log(limitKey, trans(limitKey));
      return `${trans('bet_was_changed_becouse')}: ${trans(limitKey)}`
    }

    const reachedStr = 'Reached'
    const limitReachedKey = `${limitKey}${reachedStr}`
    const limitReachedMsg = trans(limitReachedKey)
    // this.gamePlayView.model.sendCloseMsg(()=>{});
    return limitReachedMsg
  },

  handleError(message, action, demoMode, callback, trackId, context) {
    let errorObj
    let code

    if (_.isString(message)) {
      code = errorHandler.getErrorCodeFromMsg(message)
      if (code) {
        gaHelper.addError(code, message)
      }
    } else if (_.isNumber(message)) {
      message = errorHandler.getErrorByCode(message)
    }

    if (_.isObject(message)) {
      errorObj = message
      code = errorObj.code
      gaHelper.addError(errorObj.code, errorObj.msg)
      message = errorObj.msg

      if (code === 6003010 || code === 6003020) {
        message = this.getRichedCapiLimitMsg(code, action)
      }
    }

    if (action === 'R') {
      return
    }

    if (demoMode && action === 'C') {
      this.model.resetTimeLimit()
      return
    }

    if (action === 'C') {
      const data = $.parseJSON(message)
      message = trans(data.key, {
        '%win%': numbers.money(data.params.win),
        '%bet%': numbers.money(data.params.bet),
        '%time%': data.params.time,
      })
    }
    if (action === 'Q') {
      this.gamePlayView.model.sendCloseMsg(() => {})
    }
    this.displayError(
      action,
      message,
      () => {
        if (action === 'C') {
          this.model.resetTimeLimit(callback)
        } else if (action !== 'Q' && _.isFunction(callback)) {
          callback()
        }
      },
      () => {
        if (action === 'C' || action === 'Q') {
          this.gamePlayView.destroy()
        } else if (_.isFunction(callback)) {
          callback()
        }
      },
      errorObj,
      trackId,
      context,
    )
  },

  displayError(action, message, acceptCallback, denyCallback, errorObj, trackId, context) {
    let title = trans('Game message')
    let buttons = {
      ok() {
        if (_.isFunction(acceptCallback)) {
          acceptCallback()
        }
      },
    }

    if (action === 'C') {
      title = trans('Do you want to continue playing?')
      buttons = {
        yes() {
          if (_.isFunction(acceptCallback)) {
            acceptCallback()
          }
        },
        no() {
          if (_.isFunction(denyCallback)) {
            denyCallback()
          }
        },
      }
    } else if (action === 'Q') {
      title = trans('Game error')
    }

    const errorCode = errorObj?.code || '99'
    const uid = trackId || '99'
    const details = context !== undefined ? '<p class="tc"><canvas id="error-qr"></canvas></p>' : ''
    const codeHtml = `<p class="tc"><span class="gray">${errorCode} / ${uid} <br> ${new Date().toISOString()}</span></p>${details}`

    const settings = {
      title,
      content: `<h4 class="tc">${message}</h4>${codeHtml}`,
      buttons,
      overlayZIndex: this.overlayZIndex,
      css: this.defaultDialogCss,
      callback: () => {
        if (context !== undefined) {
          this.prepareErrorDetailsQrCode(context)
        }
      },
      close: () => {
        if (_.isFunction(acceptCallback)) {
          acceptCallback()
        }
        this.hideDialog(action)
      },
      hideCloseBtn: true,
    }

    this.showDialog()

    this.currentOpenDialog = SimpleDialog.dialog(settings)
  },

  prepareErrorDetailsQrCode(context) {
    if (context instanceof Error) {
      context = context.stack
        .split('\n')
        .slice(0, 5)
        .map((entry) => entry.trim())
    }

    const serialized = window.btoa(objects.serialize(context))

    QRCode.toCanvas(document.getElementById('error-qr'), serialized, {
      scale: 3,
      color: {
        light: '#0000', //transparent
      },
    })
  },

  closeCurrentOpenDialog() {
    if (this.currentOpenDialog && this.currentOpenDialog.destroy) {
      this.dialogIsShown = false
      this.currentOpenDialog.destroy()
    }
  },
})
